import { Navigation, Scrollbar } from 'swiper/modules';
import Swiper from 'swiper';

export default function initNewsSlider(id: string | undefined) {
  function initSliders() {

    const root = document.getElementById(`news-slider-${id}`);
    if (root) {
      const swiperEl = root.querySelector('.card-swiper') as HTMLElement;
      if (swiperEl) {
        /* eslint-disable no-new */
        new Swiper(swiperEl, {
          modules: [Scrollbar, Navigation],
          slidesPerView: 'auto',
          observer: true,
          observeParents: true,
          scrollbar: {
            el: `#news-slider-${id} .card-swiper-scrollbar`,
            draggable: true,
            dragClass: 'swiper-scrollbar-drag bg-dark/20! rounded-none! cursor-grab',
          },
          navigation: {
            nextEl: `#news-slider-${id} .swiper-button-next`,
            prevEl: `#news-slider-${id} .swiper-button-prev`,
          },
          spaceBetween: 16,
          breakpoints: {
            787: {
              spaceBetween: 30,
            },
          },
        });
      }
    }
  }

  initSliders();
}
